import React from 'react';

import { Row, Col } from 'antd';

import { Customer } from '../../../../../../api-client';

import './bv-customer-details.scss';

interface IBVCustomerDetails {
    customer?: Customer;
}

const BVCustomerDetails: React.FunctionComponent<IBVCustomerDetails> = ({ customer }) => (
    <div className="bv-customer-details-container">
        <Row gutter={[32, 8]}>
            <Col span={6}>
                <span>Sap Code:</span>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
                {customer?.sapCode ?? '-'}
            </Col>
            <Col span={6}>
                <span>Sales Group:</span>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
                {customer?.salesGroup ?? '-'}
            </Col>
            <Col span={6}>
                <span>Responsability Area:</span>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
                {customer?.responsabilityArea ?? '-'}
            </Col>
            <Col span={6}>
                <span>Customer Group:</span>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
                {customer?.group ?? '-'}
            </Col>
            <Col span={6}>
                <span>Account Group:</span>
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
                {customer?.accountGroup ?? '-'}
            </Col>
            {customer?.eccCustomer ? <>
                <Col span={6}>
                    <span>Sap Code Old:</span>
                </Col>
                <Col span={6} style={{ textAlign: 'right' }}>
                    {customer?.eccCustomer?.sapCode ?? '-'}
                </Col>
            </> : null}
        </Row>
    </div>
);

export default BVCustomerDetails;